export default function mask() {
    let cpfs = document.querySelectorAll("#cpf");
    let fones = document.querySelectorAll("#phone");

    cpfs.forEach(cpf => {
        $(cpf).mask('000.000.000-00', {reverse: true});
    }); 

    fones.forEach(fone => {
        $(fone).mask('(00) 0 0000-0000');
    });
}